import { ReactNode } from 'react';
import { Paper, PaperProps } from '@mantine/core';

/* -------------------------------------------------------------------------- */
/*                                    Types                                   */
/* -------------------------------------------------------------------------- */

interface FullscreenContainerProps extends Omit<PaperProps, 'children'> {
  children: ReactNode;
  isFullscreen: boolean;
  normalHeight?: string | number;
  normalMargin?: string | number;
  transitionDuration?: string;
  className?: string;
}

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function FullscreenContainer({
  children,
  isFullscreen,
  normalHeight = '390px',
  normalMargin = '1rem',
  transitionDuration = '0.3s',
  className,
  ...paperProps
}: FullscreenContainerProps) {
  const containerStyles = {
    transition: `all ${transitionDuration} ease-in-out`,
    ...(isFullscreen
      ? {
          position: 'absolute' as const,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 200,
          backgroundColor: 'white',
          margin: 0,
        }
      : {
          position: 'relative' as const,
          margin: normalMargin,
          height: normalHeight,
        }),
  };

  const paperStyles = {
    transition: `height ${transitionDuration} ease-in-out`,
    ...paperProps.style,
  };

  return (
    <div style={containerStyles} className={className}>
      <Paper
        {...paperProps}
        h={isFullscreen ? '100%' : normalHeight}
        style={paperStyles}
      >
        {children}
      </Paper>
    </div>
  );
}

export default FullscreenContainer;
